export default __webpack_public_path__ + "24b4343b0a0ddfebabf3f9d1e75b1644.png";